import { SEGURIDAD_URL, customAxios } from '../constants';
import { FETCH_COLABORADORES, CLEAR_COLABORADORES } from '../actions';
import { evalAction, serverError } from '../utils/actionError';

export function fetchColaboradores(value) {
  const config = {
    headers: {
      numPag: '1',
      cantiRegPag: '20',
    },
  };

  const data = {
    apellidos: value,
    codUsuarioGestionado: '',
    nombre: '',
  };
  //<90384_Correccion_contactos_sid_web_fdv_final -> Se añade valor activo
  const request = customAxios.post(`${SEGURIDAD_URL}/mantenimiento/usuarioRol/buscarUsuarioActivo`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'));

  return {
    type: FETCH_COLABORADORES,
    payload: request,
  };
}

export function clearColaboradores() {
  return {
    type: CLEAR_COLABORADORES,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Colaboradores.js